import { render, staticRenderFns } from "./bridged_a.vue?vue&type=template&id=1cdebe1f&"
import script from "./bridged_a.vue?vue&type=script&lang=js&"
export * from "./bridged_a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports